<template>
  <div class="rfis-validator-status">
    <div class="overview">
      <div class="head">

        <div class="status-icon">
          <img src="../../assets/stafi.png" />
        </div>
        <div class="status-title">
          Nominated FIS
        </div>
        <div class="nominate-status">
          <template v-if="nominateStatus == 1">
            Active
          </template>
          <template v-else>
            Waiting
          </template>
        </div>

      </div>

      <div class="stake-info">
        <div class="amount">
          {{ totalStakedETHShow }}
        </div>
      </div>

      <div class="amount-detail">
        <div class="self-amount">
          Self-deposited: <span class="bold">{{ selfDepositedShow }}</span>
        </div>
        <div class="apr">
          <!-- Current APR: <span class="bold">{{ currentApr }}</span> -->
          Reward last 7-day: <span class="bold">{{ lastReward }}</span>
        </div>
        <div class="commission">
          Commission: <span class="bold">{{ currentCommission }}</span>
        </div>
      </div>
    </div>

    <div class="contract">
      <div class="contract-head">
        <div class="contract-title">
          Nominated Details
        </div>
      </div>
      <div class="no-detail" v-if="this.addressItems.length == 0">
        <div class="detail-icon">
          <img src="../../assets/details.png" />
        </div>
        <div class="text">
          No Details
        </div>
      </div>

      <div class="contract-items">
        <template 
            v-for="(item, index) in addressItems"  >
            <div class="contract-item" :key="index">
              <div class="address-desc">Pool Address:</div>
              <div class="address" @click="jumpToPoolDetail(item)">{{ item.shortAddress }}</div>
              <div class="era">ERA {{ item.era }}</div>
              <div class="nominate-amount">+{{ item.amount }} FIS</div>
            </div>
          </template>
      </div>
    </div>

    <div class="deposit-btn" @click="offboard">
      Offboard
    </div>

    <DialogBtn
      v-if="dialogVisible1"
      :dialog-data="dialogData1"
      @close="cancel"
      @sure="handleOffboard"
    />

  </div>
</template>

<script>
import NumberUtil from '../../util/numberUtil.js';
import StringUtil from '../../util/stringUtil.js';
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Web3Util from '../../util/web3Util.js';
import LocalStorage from '../../util/localStorage.js';
import Rpc from '../../util/rpc.js';
import Api from '../../util/SubstrateApi.js';
import DialogBtn from '../../components/dialogbtn';
import {
  web3Enable,
  web3FromSource,
} from '@polkadot/extension-dapp';

export default {
  name: 'validatorStatus',
  components: {
    DialogBtn
  },
  data() {
    let lang = window.localStorage.getItem('lang');
    let defaultFisAmount = NumberUtil.handleFisAmountToFixed('0');
    return {
      lang: lang,
      nominateStatus: 0,
      totalStakedETH: 0,
      totalStakedETHShow: defaultFisAmount,
      selfDepositedShow: defaultFisAmount,
      lastReward: '--',
      currentApr: '--',
      currentCommission: '--',
      addressItems: [],
      exposureOthers: [],
      dialogVisible1: false,
      dialogData1: {},
    }
  },

  methods: {
    cancel() {
      this.dialogVisible1 = false;
    },
    offboard() {
      this.dialogData1 = {
        icon: require('../../assets/money.png'),
        lTitle: 'Confirm to offboard',
        content: 'Make sure your current FIS account is your Controller account',
        type: 1,
        leftBtnText: 'Cancel',
        rightBtnText: 'Offboard'
      };
      this.dialogVisible1 = true;
    },
    handleOffboard() {
      this.dialogVisible1 = false;

      Indicator.open('Loading...');

      web3Enable(Api.getWeb3EnalbeName());
      web3FromSource(Api.getPolkadotJsSource()).then(injector => {

        Api.createStafiApi().then(api => {

          let currentAccount = LocalStorage.getCurrentFisAccount();

          api.tx.rFis
              .offboard()
              .signAndSend(currentAccount, { signer: injector.signer }, (result) => {
            
            if (result.status.isInBlock) {
              Indicator.close();
              this.clickStake = false;

              result.events
                .filter(({ event: { section } }) => section === 'system')
                .forEach(({ event: { data, method } }) => {
                  if (method === 'ExtrinsicFailed') {
                    const [dispatchError] = data
                    if (dispatchError.isModule) {
                      try {
                        const mod = dispatchError.asModule;
                        const error = data.registry.findMetaError(new Uint8Array([mod.index.toNumber(), mod.error.toNumber()]));

                        let message = 'Something is wrong, please try again!';
                        if (error.name == 'NotController') {
                          message = 'Please use your controller account';
                        }
                        Toast({ 
                          message: message, 
                          duration: 3000 
                        });
                      } catch (error) {
                        Toast({ 
                          message: error.message, 
                          duration: 3000 
                        });
                      }
                    }
                  } else if (method === 'ExtrinsicSuccess') {
                    Toast({ 
                      message: 'Offboard successfully', 
                      duration: 3000 
                    });
                    setTimeout(() => {
                      this.$emit('offboardSuccess');
                    }, 3300);
                  }
                });
            } else if (result.isError) {
              Indicator.close();
              this.clickStake = false;

              Toast({ 
                message: result.toHuman(), 
                duration: 3000 
              });
            }

          }).catch((error) => {
            Indicator.close();
            this.clickStake = false;
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          });

        })
        .catch((error) => {
          Indicator.close();
          this.clickStake = false;
          Toast({ 
            message: error.message, 
            duration: 3000 
          });
        });
        
      });
      
    },
    jumpToPoolDetail(item) {
      window.open('https://stafi.subscan.io/account/' + item.address);
    },
  },

  created() {
    let currentAddress = LocalStorage.getCurrentFisAccount();

    Api.createStafiApi().then(api => {
      api.query.staking.currentEra().then(eraData => {
        let era = eraData.toJSON();
        
        api.query.staking.ledger(currentAddress).then(ledgerData => {
          let ledger = ledgerData.toJSON();
          if (ledger) {
            api.query.session.validators().then(validatorsData => {
              let validators = validatorsData.toJSON();
              if (validators && validators.length > 0 && validators.indexOf(ledger.stash) != -1) {
                this.nominateStatus = 1;
              }
            }).catch((error) => {});

            Rpc.fetchStafiValidatorApr({validatorAddress: ledger.stash}).then(result => {
              if (result.status == '80000') {
                if (result.data) {
                  let reward = '0';
                  if (result.data.rewards) {
                    reward = result.data.rewards;
                  }
                  this.lastReward = NumberUtil.handleFisAmountToFixed(reward);
                }
              } 
            });

            api.query.staking.erasStakersClipped(era, ledger.stash).then(exposureData => {
              let exposure = exposureData.toJSON();
              if (exposure) {
                this.totalStakedETHShow = NumberUtil.handleFisAmountToFixed(NumberUtil.fisAmountToHuman(exposure.total));
                this.selfDepositedShow = NumberUtil.handleFisAmountToFixed(NumberUtil.fisAmountToHuman(exposure.own));
                this.exposureOthers = exposure.others;

                if (this.exposureOthers.length > 0) {
                  api.query.rFis.pools().then(poolsData => {
                    let pools = poolsData.toJSON();
                    if (pools && pools.length > 0) {
                      pools.forEach(pool => {
                        this.exposureOthers.some(other => {
                          if (other.who == pool) {
                            this.addressItems.push({
                              address: pool,
                              shortAddress: StringUtil.replacePkh(pool, 4, 44),
                              era: era,
                              amount: NumberUtil.handleFisAmountToFixed(NumberUtil.fisAmountToHuman(other.value))
                            });
                            return true;
                          }
                        });
                      });
                    }
                  }).catch((error) => {});
                }

              }
            }).catch((error) => {});

            api.query.staking.validators(ledger.stash).then(validatorData => {
              let validatorPrefs = validatorData.toJSON();
              if (validatorPrefs) {
                let feeToHuman = NumberUtil.fisFeeToHuman(validatorPrefs.commission);
                this.currentCommission = NumberUtil.fisFeeToFixed(feeToHuman) + '%';
              }
            }).catch((error) => {});
          }

        }).catch((error) => {});

      }).catch((error) => {});

    })
    .catch((error) => {});

  }
};
</script>

<style lang="scss">

.rfis-validator-status {

  .overview {
    padding-bottom: 20px;
    border-bottom: 1px solid #474747;
  } 

  .head {
    display: flex;
    margin-top: 36px;

    .status-icon {
      margin-right: 10px;
      height: 36px;
      img {
        height: 100%;
      }
    }

    .status-title {
      font-size: 30px;
      font-weight: bold;
    }

    .nominate-status {
      color: #00F3AB;
      font-weight: bold;
      font-size: 12px;
      line-height: 36px;
      margin-left: 183px;
    }
  }

  .stake-info {
    display: flex;
    margin-left: 55px;
    margin-top: 20px;

    .amount {
      font-size: 30px;
      font-weight: bold;
      color: #00F3AB;
    }

    .btn {
      cursor: pointer;
      margin-left: 190px;
      width: 69px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      color: #23292F;
      font-weight: bold;
      background-color: #00F3AB;
      border-radius: 13px;
      text-align: center;
    }
    
  }

  .amount-detail {
    width: 190px;
    margin-top: 30px;
    margin-left: 60px;
    font-size: 12px;

    .self-amount {
      padding-bottom: 10px;
      border-bottom: 1px solid #474747;
      padding-left: 2px;
      padding-right: 24px;
    }
    .apr {
      margin-top: 10px;
      padding-left: 2px;
    }

    .commission {
      padding-left: 2px;
      margin-top: 23px;
    }

    .bold {
      font-weight: bold;
    }
  }

  .contract {
    margin-top: 30px;

    .contract-head {
      display: flex;
      padding-left: 10px;
      margin-bottom: 20px;

      .contract-title {
        font-weight: bold;
        font-size: 30px;
      }
    }

    .no-detail {
      margin-top: 31px;
      .detail-icon {
        margin-left: 61px;
        height: 107px;
        img {
          height: 100%;
        }
      }

      .text {
        margin-left: 111px;
        margin-top: 7px;
        font-size: 16px;
        font-weight: bold;
        opacity: 0.51;
      }
    }

    .contract-items {

      .contract-item {
        padding-left: 10px;
        margin-top: 10px;
        font-size: 12px;
        padding-bottom: 10px;
        border-bottom: 1px solid #474747;

        display: flex;

        .address-desc {
          margin-right: 10px;
        }

        .address {
          cursor: pointer;
          color: #00F3AB;
          font-weight: bold;
          text-decoration: underline;
          width: 130px;
        }

        .era {
          font-size: 12px;
          width: 170px;
        }

        .nominate-amount {
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
    
  }

  .deposit-btn {
    cursor: pointer;
    margin-left: 371px;
    width: 95px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #23292F;
    font-weight: bold;
    background-color: #00F3AB;
    border-radius: 13px;
    text-align: center;
    margin-top: 30px;
  }
}
  
</style>